module.exports = __webpack_public_path__ + "static/img/none.d0064724.png";